  <template>
  <div class="forgot-password">
    <v-alert v-if="showAlert" :type="alertType" dismissible>
      {{ alertMessage }}
    </v-alert>

    <v-container fill-height>
      <v-layout wrap text-center align-center justify-center>
        <v-flex sm3>
          <v-form class="mb-5">
            <v-text-field
              v-validate="'required|email'"
              :error-messages="errors.collect('email')"
              data-vv-name="email"
              type="email"
              label="Email"
              v-model="email"
              required
              dark
              autofocus
            ></v-text-field>
            <v-flex mt-5>
              <v-btn
                :loading="isLoading"
                color="#006064"
                @click="onSubmit"
                ripple
                rounded
                large
                dark
                >Réinitialiser le mot de passe</v-btn
              >
            </v-flex>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import AuthRepo from "@/repositories/authRepository";

  export default {
    name: "ForgotPassword",

    data() {
      return {
        showAlert: false,
        alertType: null,
        alertMessage: "",

        isLoading: false,

        email: null
      };
    },

    methods: {
      /**
       * Submit form
       */
      async onSubmit() {
        const isValid = await this.$validator.validate();
        if (!isValid) return;

        try {
          this.isLoading = true;

          await AuthRepo.requestPasswordReset(this.email);

          this.alertMessage = "Un email a été envoyé à l'adresse mail saisie";
          this.alertType = "success";
          this.showAlert = true;
          this.isLoading = false;
        } catch (error) {
          this.alertMessage = "Un probléme est survenu";
          this.alertType = "error";

          if (error.response.status == 404) {
            this.alertMessage = "Utilisateur non trouvé";
          }

          this.showAlert = true;
          this.isLoading = false;
        }
      }
    }
  };
</script>

<style lang="scss">
  #app {
    .forgot-password {
      height: 100%;
      background: rgb(136, 14, 79);
      background: linear-gradient(
        20deg,
        rgba(136, 14, 79, 1) 56%,
        rgba(71, 0, 77, 1) 100%
      );

      .container {
        .layout {
          .v-input {
            .v-input__control {
              .v-input__slot {
                .v-text-field__slot {
                  label {
                    &.v-label--active {
                      color: #ffffff !important;
                    }
                  }
                  input {
                    color: white !important;
                  }
                  input:-webkit-autofill,
                  input:-webkit-autofill:hover,
                  input:-webkit-autofill:focus,
                  input:-webkit-autofill {
                    -webkit-text-fill-color: white !important;
                    -webkit-box-shadow: 0 0 0px 1000px #880e4f inset;
                    box-shadow: 0 0 0px 1000px #880e4f inset;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
</style>
